import { absolutizeUrl } from './canonicalUrl';

export function organizationJsonLd(origin: string) {
  return {
    '@type': 'Organization',
    '@id': `${origin}/#organization`,
    name: 'Bilt:Spec',
    url: `${origin}/`,
    logo: `${origin}/images/brand/og-default.jpg`,
    description: 'Every car has a story. Document modifications, media, events, awards, and milestones on Bilt:Spec.',
  };
}

export function webSiteJsonLd(origin: string) {
  return {
    '@type': 'WebSite',
    '@id': `${origin}/#website`,
    name: 'Bilt:Spec',
    url: `${origin}/`,
    publisher: { '@id': `${origin}/#organization` },
    potentialAction: {
      '@type': 'SearchAction',
      target: `${origin}/search?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  };
}

export function vehicleJsonLd(input: {
  origin: string;
  url: string;
  name: string;
  description: string;
  image?: string;
  make?: string;
  model?: string;
  year?: number | string;
  ownerUsername?: string;
}) {
  const data: Record<string, unknown> = {
    '@type': 'Vehicle',
    name: input.name,
    url: input.url,
    description: input.description,
    image: input.image ? absolutizeUrl(input.image, input.origin) : undefined,
  };
  if (input.make) {
    data.brand = { '@type': 'Brand', name: input.make };
    data.model = input.model;
  }
  if (input.year) {
    data.vehicleModelDate = String(input.year);
  }
  if (input.ownerUsername) {
    data.author = {
      '@type': 'Person',
      name: `@${input.ownerUsername}`,
      url: `${input.origin}/${encodeURIComponent(input.ownerUsername)}`,
    };
  }
  return data;
}

export function defaultSiteGraph(origin: string) {
  return [organizationJsonLd(origin), webSiteJsonLd(origin)];
}

export function profileJsonLd(input: {
  origin: string;
  url: string;
  title: string;
  description: string;
  displayName: string;
  username: string;
  image?: string;
}) {
  return {
    '@type': 'ProfilePage',
    name: input.title,
    url: input.url,
    description: input.description,
    mainEntity: {
      '@type': 'Person',
      name: input.displayName,
      identifier: `@${input.username}`,
      url: input.url,
      image: input.image ? absolutizeUrl(input.image, input.origin) : undefined,
    },
  };
}
